import { render, staticRenderFns } from "./DinamicTip.vue?vue&type=template&id=63bae191&"
import script from "./DinamicTip.vue?vue&type=script&lang=js&"
export * from "./DinamicTip.vue?vue&type=script&lang=js&"
import style0 from "./DinamicTip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports